import { Grid } from "@mui/material";
import React from "react";
import { ScheduleMeeting } from "react-schedule-meeting";
import FormFileInputField from "../../../../Components/form/FormInputFeild";
import FormTelInput from "../../../../Components/form/FormTelInput";
import FormTextField from "../../../../Components/form/FormTextFeild";

export default function AppointmentInfo({ control, setValue }) {
  const onTimeSelect = (e) => {
    setValue();
  };
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <FormTextField
          placeholder="Name"
          label="Name"
          fieldname="name"
          control={control}
          required
          onlyText
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          placeholder="Email address"
          label="Email"
          fieldname="email"
          control={control}
          rules={{
            pattern: {
              value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i,
              message: "Invalid email",
            },
          }}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTelInput
          label="Phone no"
          fieldname="phone"
          required
          control={control}
        />
      </Grid>
      <Grid item xs={12}>
        <FormFileInputField
          label="Please upload prescription provided by the doctor"
          control={control}
          fieldname="attachments"
          acceptedExtensions={["png", "jpg", "jpeg", "pdf"]} // Include all common image extensions and PDFs
          // required={true}
          maxFileSize={32 * 1024 * 1024} // Max file size of 32 MB
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          placeholder="Details"
          label="Details"
          fieldname="details"
          control={control}
          required
          multiline
        />
      </Grid>
    </Grid>
  );
}
